module.exports = __webpack_public_path__ + "static/media/Invest_In_Vision copy.6e4aa979.jpg";